/**
 * Editor page root component
 */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import _ from 'lodash'

import EditApp from '../editor/EditApp'
import Layout from '../shared/Layout'
import Header from '../editor/EditorHeader'
import Footer from '../editor/Footer'
import EditorSidebarContainer from '../editor/sidebar/EditorSidebarContainer'
import * as editorMode from 'constants/editorMode'

class Editor extends Component {

  constructor () {
    super()

    this.state = {
      appId: null,
      editorMode: editorMode.EDIT
    }
  }

  componentWillReceiveProps (nextProps) {
    const { params } = this.props.match
    if (params.appId && nextProps.match.params.appId && params.appId !== nextProps.match.params.appId) {
      this.setState({ appId: nextProps.match.params.appId })
    }
  }

  onChangeEditorMode = (m) => {
    this.setState({editorMode: m})
  }

  renderHeader () {
    const { apps, match } = this.props
    const appId = match.params.appId
    const app = _.get(apps, appId, {})
    return (
      <Header
        app={app}
        editorMode={this.state.editorMode}
        onChangeEditorMode={this.onChangeEditorMode}
      />
    )
  }

  render () {
    // console.log('editor render')
    const { editorMode } = this.state
    const { apps, match } = this.props
    const appId = match.params.appId
    const app = (apps) ? apps[appId] : {}
    if (!app) return null

    return (
      <Layout
        header={this.renderHeader()}
        sidebar={<EditorSidebarContainer app={app} editorMode={editorMode} />}
        main={<EditApp app={app} editorMode={editorMode} />}
        footer={<Footer app={app} />}
        editorMode={editorMode}
      />
    )
  }
}

Editor.propTypes = {
  match: PropTypes.object.isRequired,
  apps: PropTypes.object.isRequired,
}

const mapStateToProps = (state) => ({
  apps: state.apps,
})

export default connect(mapStateToProps)(Editor)



// WEBPACK FOOTER //
// ./src/components/pages/Editor.js